<template>
<form ref="form" name="form_auth" method="post" :action="callUrl">
    <input type="hidden" name="reg_cert_key" :value="regCertKey" />

    <iframe id="kcp_cert" name="kcp_cert" width="100%" height="700" frameborder="0" scrolling="no" style="display: none"></iframe>
</form>
</template>

<script>
import axios from "@/plugins/axios";
export default {
    data() {
        return {
            callUrl: "",
            regCertKey: "",
        }
    },
    mounted() {
        window.authComplete = (payload) => {
            window?.parent?.authComplete(payload);
            window?.opener?.authComplete(payload);
        };

        this.auth();
    },
    beforeDestroy() {
        window.authComplete = undefined;
        window.auth = undefined;
    },
    methods: {
        async auth() {
            // 거래등록 → 인증창 호출주소(call_url) 및 reg_cert_key 발급
            var { callUrl, regCertKey } = await axios.post("/api/plugins/kcp/kcp-cert/request").then(res => res.data);

            this.callUrl = callUrl;
            this.regCertKey = regCertKey;

            this.$nextTick(() => {
                var form = this.$refs.form;

                if( navigator.userAgent.indexOf("Android") > - 1 || navigator.userAgent.indexOf("iPhone") > - 1 )
                {
                    self.name = "auth_popup";
                }
                else{
                    var width = 410;
                    var height = 500;
                    var leftpos = screen.width / 2 - (width / 2);
                    var toppos = screen.height / 2 - (height / 2);
                    var feature = `width=${width}, height=${height}, toolbar=no, status=no, statusbar=no, menubar=no, scrollbars=no, resizable=no, left=${leftpos}, top=${toppos}`;
                    window.open('about:blank', 'auth_popup', feature);
                    form.target = "auth_popup";
                }
                form.submit();
            });
        },
    },
};
</script>
